module.exports = __webpack_public_path__ + "dimer/static/img/discoveryPageBG1.fa1fe3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discoveryPageBG1.jpg
// module id = qj41
// module chunks = 0